import axios from "axios";
import { decryptionData, generateFilterDate, processTopicKeywords } from '@/components/utils/utils.js';
import VueApexCharts from 'vue-apexcharts';
import Notification from '@/components/Notification';
import Toppersonbubblepinnedhistory from '@/components/Toppersonbubblepinnedhistory';
import SettingModal from '@/views/BrandAnalysis/components/SettingModal.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Toppersonbubblepinnedhistory,
    apexcharts: VueApexCharts,
    SettingModal: SettingModal,
    Notification: Notification
  },
  data: function() {
    return {
    titlePinned: 'Pinned Person - Post Based',
    subtitlePinned: 'Tracked Author Contribution',
    namePinned: 'Person ',
      
    sentimentActive: false,
    nerObjectSentiment: '',
    sentimentModule: '',
    activeContentIndex: 1,
    typesourcePinned:1,
    transitionName: 'slide-left',
      groupAnalysisList: [],
      selectedGroupAnalysis: null,
      sourceCollection: "",
      selectedDataSource: 0,
      itemsDataSource:[],
      selectedPinned:1,
      itemsDataPinned: [//choice select
        {valuePinned: 1, namePinned: "Pinned Person" },
        {valuePinned: 2, namePinned: "Pinned Organization" }
      ],

      selectedDataCategory: 1,
      itemsDataCategory: [//choice select
        {valueCategory: 1, nameCategory: "Topic And Keyword" },
        {valueCategory: 2, nameCategory: "Just Objects" }
      ],


      listPerson: "",
      listDataChart: "",
      listDataContent: "",
      selectedContent: "",
      selectedPerson: "",
      listContent: "",
      menu: false,
      overlayDialogLoading: false,
      dialogLoading: false,
      dialogConfirmReset: false,
      click: "",
      settingDialog: false,
      selectedTopic: "",
      selectedTopic2: "",
      selectedPeriode: "This Week",
      topicsentiment: [],
      topickeywordsentiment: [],
      periodeBerita: [
        { name: 'Today', value: 'Today' },
        { name: 'From Yesterday', value: 'From Yesterday' },
        { name: 'This Week', value: 'This Week' },
        { name: 'From Previous Week', value: 'Previous Week' },
        { name: 'This Month', value: 'This Month' },
        { name: 'Previous Month', value: 'Previous Month' }
      ],
      isShowDate: false,
      showDateStart: "",
      showDateEnd: "",
      dateStart: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateEnd: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      pageplay: 10,
      page: 1,
      pagelength: 0,
      activeTab:"",
      statusFilter: "",
      isClickBubleOrg: "",
      isClickWord: "",
      resetcolorClicked: false,
      updateSocket: "",
      alert: false,
      colorAlert: "",
      message: "",
      Settanggal: [],
      startDate: [],
      endDate: [],
      sentimentanalysis: {
        chart: {
          id: 'Memory Usage',
          background: 'transparent',
          events: {
            markerClick: (event, chartContext, {  dataPointIndex, w }) => {
              const category = w.globals.categoryLabels[dataPointIndex]
              this.onPointClick(category)
            }
          }
        },

        tooltip: {
          shared: true,     
          intersect: false, 
           followCursor: true, 
          x: {
            show: true,     
            format: 'yyyy-MM-dd' // atau sesuaikan jika bukan format tanggal
          },
          y: {
            formatter: function(val) {
              return val != null ? val : '0';
            }
          }
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
          connectNulls: true
        },
        colors: ['#45AF5B', '#FF1752', '#008FFB', '#FFB000', '#814AD6', '#000'],
        xaxis: {
          type: 'category', // pastikan ini ada
          // categories: [],
          labels: {
            style: {}
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        }
      },
      seriessentiment: []
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    }
  },
  mounted() {
    this.loadTopic();
    this.loadGroupAnalysis();
    //  this.$emit('mounted');
    // this.$nextTick(() => {
    //   if (this.$refs.topPersonComponent) {
    //     this.$refs.topPersonComponent.loadKontenBerita();
    //   }
    // });
    
  },
  

  methods: {

    async loadGroupAnalysis() {
      try {
        const response = await axios.get(
          "analisis-group-user",
          {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          }
        );

        const dataDecryption = decryptionData(response.data.token);

        this.groupAnalysisList = dataDecryption.data ?? [];

      } catch (error) {
        console.error("Failed to load Group Analysis:", error);
      }
    },

    async loadDiscoverPerson() {

      if(this.selectedPinned == 1){
        this.namePinned = 'Person'
        this.titlePinned = 'Pinned Person - Post Based'
        this.subtitlePinned = 'Tracked Author Contribution'
      }else{
        this.namePinned = 'Entity'
        this.titlePinned = 'Pinned Organization - Post Based'
        this.subtitlePinned = 'Tracked Organizational Contribution'
      }

      let selectedPinned = this.selectedPinned;
      let url = '/pinned-dash';
      let source = this.selectedDataSource ?? this.$store.data_source_glob;
      let typesourceResult = this.typesourcePinned == 1 ? 2 : 1;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      try {
        const response = await axios.post(
          url,
          {
            start_date: this.$store.date_start_glob,
            end_date: this.$store.date_end_glob,
            topic_id: this.$store.topic_glob,
            keyword: this.$store.topic_glob2,
            source,
            startpage: 0,
            pageShow: this.pageplay,
            sourcePinned: selectedPinned,
            typesourcePinned: typesourceResult,
            typeParm:this.selectedDataCategory
          },
          { headers: { 'auth-token': localStorage.getItem('token_app') } }
        );

        const data_res = decryptionData(response.data.token);

        if (data_res.status === 200) {
          this.listPerson = data_res.data_bubble;
          this.$store.commit("dataBubble", { bubble_data: data_res });

          this.listDataChart = data_res.data_chart.map(item => ({
            objectContentId: item.objectId,
            objectContent: item.object,
            count_chart: item.count_chart,
            chart_date: item.chart_date,
          }));

          this.listDataContent = this.listDataChart;

          const allDatesSet = new Set();
          this.listDataChart.forEach(item => {
            item.chart_date.forEach(dateItem => {
              allDatesSet.add(dateItem.period);
            });
          });
          const allDates = Array.from(allDatesSet).sort();

          this.seriessentiment = this.listDataChart.map(item => {
            const dateMap = new Map();
            item.chart_date.forEach(dateItem => {
              dateMap.set(dateItem.period, dateItem.jumlah);
            });

            const dataFormatted = allDates.map(date => ({
              x: date,
              y: dateMap.get(date) ?? 0,
            }));

            return {
              name: item.objectContent,
              data: dataFormatted,
            };
          });

          // this.$refs.topPersonComponent.loadKontenBerita();
          

          this.loadDiscoverPersonContent(this.listDataChart[0])
          // ✅ Tunggu DOM update (grafik, bubble, dsb)
          await this.$nextTick();
              // this.$refs.topPersonComponent.loadKontenBerita();
          window.dispatchEvent(new Event("resize"));
          
          setTimeout(() => {
              this.$refs.topPersonComponent.loadKontenBerita();
          }, 1000);

          setTimeout(() => {
            this.overlayDialogLoading = false;
            this.dialogLoading = false;
          }, 300);
        } else {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.$refs.alert.error_response(204, data_res.msg);
        }
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (!e?.data_res) {
          this.alert = true;
          this.message = "API pinned-history-discover-person refused to connect";
          this.colorAlert = "red";
          setTimeout(() => (this.alert = false), 3000);
        }

        switch (e?.data_res?.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.error("Unhandled error", e);
            break;
        }
      }
    },

            
    filterReset() {
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
        ner_person_glob: "",
        ner_organization_glob: "",
      });
    },

    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.dateStart);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");
      dateString = dateString.split(" ");
      this.showDateStart = dateString;
      var date3 = new Date(this.dateEnd);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();
      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");
      dateString2 = dateString2.split(" ");
      this.showDateEnd = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedTopic2,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.dateStart,
        date_end_glob: this.dateEnd,
        is_show_date_glob: this.isShowDate
      });
    },
    async loadTopic() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      try {
        const [keywordSelectResponse, topicKeywordResponse] = await Promise.all([
          axios.get("keyword_select", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json',
            validateStatus: function (status) {
              return status === 200; // hanya status 200 yang dianggap sukses
            }
          }),
          axios.get("topic-keyword", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json',
            validateStatus: function (status) {
              return status === 200; // hanya status 200 yang dianggap sukses
            }
          })
        ]);

        const dataDec = decryptionData(keywordSelectResponse.data.token);
        this.posts = dataDec.keyword;
        const data = dataDec.keyword;
        const collections = dataDec.collection;

        const topicKeywordData = decryptionData(topicKeywordResponse.data.token);
        const topicKeywordList = topicKeywordData.data.filter(item => item.GROUP_STATUS == 1);

        const completedTopicData = processTopicKeywords(data, collections, topicKeywordList);

        for (let i = 0; i < completedTopicData.length; i++) {
          //sincron data topic sentiment
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = completedTopicData[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicsentiment.push(completedTopicData[i]);
        }

        if (typeof this.selectedTopic === "string") {
          for (let i = 0; i < this.topicsentiment.length; i++) {
            if (this.selectedTopic == this.topicsentiment[i].TOPIC) {
              this.selectedTopic = this.topicsentiment[i].SEQ_ID;
              this.$store.topic_glob = this.selectedTopic;
            }
          }
        }

        this.$store.commit("addTopicKeyword", {
          //send parameter store
          topickeywordsentiment_glob: completedTopicData,
        });
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < completedTopicData.length; i++) {
          //sincron data topic sentiment
          if (completedTopicData[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < completedTopicData[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  this.selectedTopic2 = all;
                } else {
                  this.selectedTopic2 = this.$store.topic_glob2;
                }
              }
              this.topickeywordsentiment.push(completedTopicData[i].KEYWORD[x].KEYWORD);
            }
          }
        }

        this.isShowDate = this.$store.is_show_date_glob;
        var date_start = this.dateStart;
        var date_end = this.dateEnd;
        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let date_v = generateFilterDate(periode);
          date_start = date_v.start_date;
          date_end = date_v.end_date;
        }

        // coolection parameter
        if (this.$store.collectionstore == "" || this.$store.collectionstore == undefined) {
          this.$store.commit("collectionactive", {
            collection_send: collections,
            collection_select_send: collections[0].ID,
          });
          this.itemsDataSource = collections;
          this.selectedDataSource = collections[0].ID;
        } else {
          this.itemsDataSource = collections;
          this.selectedDataSource = this.$store.collectionSelectstore;
        }
        // end coolection parameter
        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          // send parameter store
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedTopic2,
            data_source_glob: this.selectedDataSource,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: date_start,
            date_end_glob: date_end,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedTopic2 = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.dateStart = this.$store.date_start_glob;
          this.dateEnd = this.$store.date_end_glob;
        }
        if (completedTopicData.length > 0) {
          this.loadDiscoverPerson();
        }
        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }

        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 3000);
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (!e.response) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "API Keyword Select Refused To Connect";
          this.colorAlert = "red";
          return;
        }
        const status = e.response?.status;
        const msg = e.response?.msg;
        this.errors = msg;
        switch (status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      }
    },

    async parameter_proses_topic() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.topickeywordsentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topickeywordsentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                this.selectedTopic2 = all;
              } else {
                this.selectedTopic2 = this.$store.topic_glob2;
              }
            }
            this.topickeywordsentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameter_proses_keyword() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      this.parameter_proses_periode();
    },
    async parameter_proses_periode() {
      let date_start = this.dateStart;
      let date_end = this.dateEnd;
      if (this.selectedPeriode != 'Custom') {
        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generateFilterDate(periode);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      this.showPeriodeDate();
    },
    async parameter_proses_custom() {
      this.selectedPeriode = "Custom";
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },

    onPointClick(date) {

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date,
        date_end_glob: date,
        is_show_date_glob: this.isShowDate
      });
      this.loadDiscoverPerson();
    },
      

    async nextContent() {
      if (this.activeContentIndex > 0) {
        this.transitionName = 'slide-left';
        this.activeContentIndex--;
        this.typesourcePinned = 2
        await this.loadarr(this.listDataContent[this.activeContentIndex]);
      }
    },
    async prevContent() {

      if (this.activeContentIndex < this.listDataContent.length - 1) {
        this.transitionName = 'slide-right';
        this.activeContentIndex++;
        this.typesourcePinned = 1
        await this.loadarr(this.listDataContent[this.activeContentIndex]);
      }
    },
    
    async loadarr(item) {
      console.log(item)
      await this.loadDiscoverPerson()
    },

    async loadDiscoverPerson() {
      if(this.selectedPinned == 1){
        this.namePinned = 'Person'
        if( this.activeContentIndex == 0){
          this.titlePinned = 'Pinned Person - Post Based'
          this.subtitlePinned = 'Tracked Author Contribution'
        }else{
          this.titlePinned = 'Pinned Person - Mention Based'
          this.subtitlePinned = 'Tracked Individuals Performance'
        }

      }else{
        this.namePinned = 'Entity'
        if( this.activeContentIndex == 0){
          this.titlePinned = 'Pinned Organization - Post Based'
          this.subtitlePinned = 'Tracked Organizational Contribution'
        }else{
          this.titlePinned = 'Pinned Organization - Mention Based'
          this.subtitlePinned = 'Tracked Organizational Performance'
        }
      }

      this.sentimentActive = false
      let selectedPinned = this.selectedPinned;
      let url = '/pinned-dash';
      let source = this.selectedDataSource ?? this.$store.data_source_glob;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      let typesourceResult = this.typesourcePinned == 1 ? 2 : 1;
      try {
        const response = await axios.post(
          url,
          {
            start_date: this.$store.date_start_glob,
            end_date: this.$store.date_end_glob,
            topic_id: this.$store.topic_glob,
            keyword: this.$store.topic_glob2,
            source,
            startpage: 0,
            pageShow: this.pageplay,
            sourcePinned: selectedPinned,
            typesourcePinned: typesourceResult,
            nerObject: '',
            sentimentModule:'',
            sentimentActive: '',
            typeParm:this.selectedDataCategory
          },
          { headers: { 'auth-token': localStorage.getItem('token_app') } }
        );

        const data_res = decryptionData(response.data.token);

        if (data_res.status === 200) {
          this.listPerson = data_res.data_bubble;
          this.$store.commit("dataBubble", { bubble_data: data_res });

          this.listDataChart = data_res.data_chart.map(item => ({
            objectContentId: item.objectId,
            objectContent: item.object,
            count_chart: item.count_chart,
            chart_date: item.chart_date,
          }));

          this.listDataContent = this.listDataChart;

          const allDatesSet = new Set();
          this.listDataChart.forEach(item => {
            item.chart_date.forEach(dateItem => {
              allDatesSet.add(dateItem.period);
            });
          });
          const allDates = Array.from(allDatesSet).sort();

          this.seriessentiment = this.listDataChart.map(item => {
            const dateMap = new Map();
            item.chart_date.forEach(dateItem => {
              dateMap.set(dateItem.period, dateItem.jumlah);
            });

            const dataFormatted = allDates.map(date => ({
              x: date,
              y: dateMap.get(date) ?? 0,
            }));

            return {
              name: item.objectContent,
              data: dataFormatted,
            };
          });

          // this.$refs.topPersonComponent.loadKontenBerita();
          

          this.loadDiscoverPersonContent(this.listDataChart[0])
          // Tunggu DOM update (grafik, bubble, dsb)
          await this.$nextTick();
              // this.$refs.topPersonComponent.loadKontenBerita();
          window.dispatchEvent(new Event("resize"));
          
          setTimeout(() => {
              this.$refs.topPersonComponent.loadKontenBerita();
          }, 1000);

          setTimeout(() => {
            this.overlayDialogLoading = false;
            this.dialogLoading = false;
          }, 300);
        } else {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.$refs.alert.error_response(204, data_res.msg);
        }
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (!e?.data_res) {
          this.alert = true;
          this.message = "API pinned-history-discover-person refused to connect";
          this.colorAlert = "red";
          setTimeout(() => (this.alert = false), 3000);
        }

        switch (e?.data_res?.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.error("Unhandled error", e);
            break;
        }
      }
    },


    async loadDiscoverPersonContent(item) {
        if(this.sentimentActive == false){
          
          this.page = 1
        

          this.selectedContent = item.objectContentId;
          this.selectedPerson = item.objectContent;
          this.overlayDialogLoading = true;
          this.dialogLoading = true;

          let source = this.selectedDataSource;
          if(this.selectedDataSource == undefined){
            source = this.$store.data_source_glob;
          }

              
          let selectedPinned = this.selectedPinned;
          let url = 'pinned-content-dash';
          let typesourceResult = this.typesourcePinned == 1 ? 2 : 1;
          let requestBody = {
              start_date: this.$store.date_start_glob,
              end_date: this.$store.date_end_glob,
              topic_id: this.$store.topic_glob,
              keyword: this.$store.topic_glob2,
              objecId: this.selectedContent,
              source: source,
              startpage: 0,
              pageShow: this.pageplay,
              sourcePinned: selectedPinned,
              typesourcePinned: typesourceResult,
              nerObject: '',
              sentimentModule: '',
              sentimentActive: '',
              typeParm:this.selectedDataCategory
          };
          axios.post(url,requestBody,
            { headers: { 'auth-token': localStorage.getItem('token_app') } },
            { dataType: 'json' }
          )
          .then((response) => {
            // alert('aaa')
            const data_res = decryptionData(response.data.token);
            this.listContent = data_res.data_content.content;
            this.sourceCollection = data_res.data_content.sourceCollection;
            this.pagelength = data_res.data_content.pageleght;
            window.dispatchEvent(new Event("resize"));
            setTimeout(() => {
              this.overlayDialogLoading = false;
              this.dialogLoading = false;
            }, 1000);
          })
          .catch((e) => {
            if (!e.data_res) {
              this.alert = true;
              setTimeout(() => {
                this.alert = false;
              }, 3000);
              this.message = "API pinned-history-content refused to connect";
              this.colorAlert = "red";
            }
            this.errors = e.data_res.msg;
            switch (e.data_res.status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              default:
                console.log("some other error"); // end up here all the time
                break;
            }
          });
        }else{
          this.loadDiscoverPersonContentSentiment(item,this.nerObjectSentiment)
        }

    },
    


















    handleBubbleClick(clickedName) {
      
        this.nerObjectSentiment = clickedName
        this.sentimentActive = true
        this.page = 1;
        this.loadDiscoverPersonSentiment(clickedName);
    },

    async loadDiscoverPersonSentiment(nerObject) {
      let selectedPinned = this.selectedPinned;
      let url = '/pinned-dash-sentiment';
      let source = this.selectedDataSource ?? this.$store.data_source_glob;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      try {
          let typesourceResult = this.typesourcePinned == 1 ? 2 : 1;
        const response = await axios.post(
          url,
          {
            start_date: this.$store.date_start_glob,
            end_date: this.$store.date_end_glob,
            topic_id: this.$store.topic_glob,
            keyword: this.$store.topic_glob2,
            source,
            startpage: 0,
            pageShow: this.pageplay,
            sourcePinned: selectedPinned,
            typesourcePinned: typesourceResult,
            nerObject: nerObject,
            sentimentModule: this.sentimentModule,
            sentimentActive: this.sentimentActive,
            typeParm:this.selectedDataCategory
          },
          { headers: { 'auth-token': localStorage.getItem('token_app') } }
        );

        const data_res = decryptionData(response.data.token);

        if (data_res.status === 200) {
          this.listPerson = data_res.data_bubble;
          // this.$store.commit("dataBubble", { bubble_data: data_res });

          this.listDataChart = data_res.data_chart.map(item => ({
            objectContentId: item.objectId,
            objectContent: item.object,
            count_chart: item.count_chart,
            chart_date: item.chart_date,
          }));

          this.listDataContent = this.listDataChart;

          const allDatesSet = new Set();
          this.listDataChart.forEach(item => {
            item.chart_date.forEach(dateItem => {
              allDatesSet.add(dateItem.period);
            });
          });
          const allDates = Array.from(allDatesSet).sort();

          this.seriessentiment = this.listDataChart.map(item => {
            const dateMap = new Map();
            item.chart_date.forEach(dateItem => {
              dateMap.set(dateItem.period, dateItem.jumlah);
            });

            const dataFormatted = allDates.map(date => ({
              x: date,
              y: dateMap.get(date) ?? 0,
            }));

            return {
              name: item.objectContent,
              data: dataFormatted,
            };
          });

          // this.$refs.topPersonComponent.loadKontenBerita();
          this.loadDiscoverPersonContentSentiment(this.listDataChart[0],nerObject)
          // ✅ Tunggu DOM update (grafik, bubble, dsb)
          await this.$nextTick();
              // this.$refs.topPersonComponent.loadKontenBerita();
          window.dispatchEvent(new Event("resize"));
          
          // setTimeout(() => {
          //     this.$refs.topPersonComponent.loadKontenBerita();
          // }, 1000);

          setTimeout(() => {
            this.overlayDialogLoading = false;
            this.dialogLoading = false;
          }, 300);
        } else {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.$refs.alert.error_response(204, data_res.msg);
        }
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (!e?.data_res) {
          this.alert = true;
          this.message = "API pinned-history-discover-person refused to connect";
          this.colorAlert = "red";
          setTimeout(() => (this.alert = false), 3000);
        }

        switch (e?.data_res?.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.error("Unhandled error", e);
            break;
        }
      }
    },

    async loadDiscoverPersonContentSentiment(item,nerObject) {
    this.page = 1
    

      // this.selectedContent = item.objectContentId;
      // this.selectedPerson = item.objectContent;
      this.sentimentModule = item.objectContent;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      let source = this.selectedDataSource;
      if(this.selectedDataSource == undefined){
        source = this.$store.data_source_glob;
      }

          console.log('testing')
          console.log(nerObject);
          
      let selectedPinned = this.selectedPinned;
      let url = 'pinned-content-dash-sentiment';
      let typesourceResult = this.typesourcePinned == 1 ? 2 : 1;
      let requestBody = {
          start_date: this.$store.date_start_glob,
          end_date: this.$store.date_end_glob,
          topic_id: this.$store.topic_glob,
          keyword: this.$store.topic_glob2,
          objecId: this.selectedContent,
          source: source,
          startpage: 0,
          pageShow: this.pageplay,
          sourcePinned: selectedPinned,
          typesourcePinned: typesourceResult,
          nerObject: nerObject,
          sentimentModule: item.objectContent,
          sentimentActive: this.sentimentActive,
          typeParm:this.selectedDataCategory
          
      };
      axios.post(url,requestBody,
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        // alert('aaa')
        const data_res = decryptionData(response.data.token);
        this.listContent = data_res.data_content.content;
        this.sourceCollection = data_res.data_content.sourceCollection;
        this.pagelength = data_res.data_content.pageleght;
        window.dispatchEvent(new Event("resize"));
        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 1000);
      })
      .catch((e) => {
        if (!e.data_res) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "API pinned-history-content refused to connect";
          this.colorAlert = "red";
        }
        this.errors = e.data_res.msg;
        switch (e.data_res.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      });
    },


    


    // pagenation content sentiment dan pinned 
    async handlePageChange(value) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      const startPage = this.pageplay * (value - 1);

      let source = this.selectedDataSource;
      if(this.selectedDataSource == undefined){
        source = this.$store.data_source_glob;
      }
      
      let selectedPinned = this.selectedPinned;
      
      let url = '/pinned-content-dash';
      if( this.sentimentActive == true){
          url = '/pinned-content-dash-sentiment'
      }
      
      let typesourceResult = this.typesourcePinned == 1 ? 2 : 1;
      let requestBody = {
          start_date: this.$store.date_start_glob,
          end_date: this.$store.date_end_glob,
          topic_id: this.$store.topic_glob,
          keyword: this.$store.topic_glob2,
          objecId: this.selectedContent,
          source: source,
          startpage: startPage,
          pageShow: this.pageplay,
          sourcePinned: selectedPinned,
          typesourcePinned: typesourceResult,
          nerObject:  this.nerObjectSentiment,
          sentimentModule: this.sentimentModule,
          sentimentActive: this.sentimentActive,
          typeParm:this.selectedDataCategory
        };
      try {
        const headers = {
          headers: {
            'auth-token': localStorage.getItem('token_app')
          }
        };
        const data1 = await axios.post(url, requestBody, headers);
          const data_res = decryptionData(data1.data.token);
          this.listContent = data_res.data_content.content;
          this.sourceCollection = data_res.data_content.sourceCollection;
          setTimeout(() => {
            this.overlayDialogLoading = false;
            this.dialogLoading = false;
          }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        }, 1000);
      }
    }
  }
}